import { ALL_NAV_HIDE_FLAGS, DEFAULT_HIDDEN_FLAGS } from "@/lib/navFeatureFlags";

/**
 * @param {{ variation: (flag: string, defaultValue: boolean) => unknown }} ldClient
 * @returns {Record<string, boolean>}
 */
export function readHiddenFlagsFromClient(ldClient) {
  /** @type {Record<string, boolean>} */
  const hiddenFlags = { ...DEFAULT_HIDDEN_FLAGS };
  for (const flag of ALL_NAV_HIDE_FLAGS) {
    hiddenFlags[flag] = ldClient.variation(flag, false) === true;
  }
  return hiddenFlags;
}
